import {createContext,useContext} from 'solid-js';
import { ITheme } from 'Shared/ITheme';
import { backendTheme as backendThemeFunc } from 'Shared/backend/Theme';
import { artistTheme as artistThemeFunc } from 'Shared/artists/Theme';


const ThemeContext = createContext();

export function ThemeProvider(P:{theme,setTheme}) 
{
	return (
		<ThemeContext.Provider value={P}>
			{P.children}
		</ThemeContext.Provider>
	);
}

export function useSetTheme()
{
	return useContext(ThemeContext).setTheme;
}

////////////// \\\\\\\\\\\\\\

export function sharedTheme():ITheme
{
	return useContext(ThemeContext).theme;
}

export function artistTheme(): ReturnType<typeof artistThemeFunc>
{
	return useContext(ThemeContext).theme;
}

/* This is for VENUES. XXX maybe rename to backendTheme() in time. */
export function theme(): ReturnType<typeof backendThemeFunc>
{
	return useContext(ThemeContext).theme;
}

